import React, { Component } from 'react';
import { LoadingStyle } from './loadingComp';

export default class Loading extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        return (<LoadingStyle>
            <div className="loading">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </LoadingStyle>);
    }
}